import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { OrganizationDto } from 'src/app/bo/organization';
import { SharedOrganizationService } from 'src/app/services/organization.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserDashboardComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly organizations = signal<OrganizationDto[]>([]);
  protected readonly selectedOrganization = signal<OrganizationDto>(null);
  protected readonly loadMetabase = signal(true);
  
  constructor(
    private readonly keycloakUtilisateurService: KeycloakUtilisateurService,
    private readonly sharedOrganizationService: SharedOrganizationService
  ) { }

  ngOnInit(): void {
    this.sharedOrganizationService.selectedOrganization$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(org => {
      if (org) {
        this.selectedOrganization.set(org);
        this.reloadMetabase();
      }
    });
      
    this.loadOrganizations();
  }
  
  loadOrganizations(): void {
    this.keycloakUtilisateurService.getCurrentUserOrganizations()
      .then(organizations => {
        this.organizations.set(organizations);
        const currentOrg = this.sharedOrganizationService.getCurrentSelectedOrganization();
        if (currentOrg) {
          this.selectedOrganization.set(currentOrg);
          this.reloadMetabase();
        }
      })
      .catch(error => {
        console.error('Error loading organizations:', error);
      });
  }
  
  reloadMetabase() {
    this.loadMetabase.set(false);
    
    setTimeout(() => {
      this.loadMetabase.set(true);
    }, 100);
  }
  
  }

